import Api from '../../services/Api';

const getInfoCompany = async () => {
    const url = 'gestao/loja',
        request = await Api.get(url),
        response = request.data.data,
        { loja, usuario } = response ?? {};
    return { loja, usuario };
};

const saveDispCompany = async (isDisponivel) => {
    return Api.put('gestao/loja/disponibilidade', isDisponivel)

        .then((response) => {
            const { data } = response;

            return data;
        })
        .catch((error) => {
            throw error;
        });
};

export { getInfoCompany, saveDispCompany };
